import riot from 'riot';
import ajax from 'app/data/ajax';
import { localStore } from 'utils/storage';
import { toLocalizedRiotUrl } from 'tradera-apps/syi/script/app_react/utils/language';

const service = riot.observable();
let storageKey;
let rootUrl;

const get = function(url, data, onSuccess, onError) {
    ajax({
        url: url,
        method: 'GET',
        data: data,
        traditional: true,
        cache: false,
        statusCode: {
            200: function(response) {
                onSuccess(response);
            }.bind(this),
            500: function(response) {
                if (onError) {
                    onError(response);
                }
            }
        }
    });
};

service.setRootUrl = function(url) {
    rootUrl = toLocalizedRiotUrl(url);
};

service.setStorageKey = function(key) {
    storageKey = key;
};

service.getFeedbackItems = function(transactionIds, onSuccess, onError) {
    let data = {
        ids: transactionIds
    };

    const url = rootUrl + 'items';

    get(url, data, onSuccess, onError);
};

service.getAllFeedbackItems = function(skip, take, onSuccess, onError) {
    let data = {
        skip: skip || 0,
        take: take || 10
    };
    let url = rootUrl + 'pageditems';

    get(url, data, onSuccess, onError);
};

const getFeedbackStorageAsArray = function() {
    let currentStorageArray = localStore.getItem(storageKey);

    if (!Array.isArray(currentStorageArray)) {
        currentStorageArray = [];
    }

    return currentStorageArray;
};

const _mergeAndSortStorage = function(newStorageArray, newItems, maxStorage) {
    newStorageArray = newStorageArray.filter(
        item => !newItems.find(newItem => newItem.text === item.text)
    );

    newStorageArray = newStorageArray.concat(newItems);
    newStorageArray.sort(function(curr, next) {
        // Sorting on multiple values are tricky - but so am I.
        return (
            next.counter +
            '.' +
            next.searchTime -
            (curr.counter + '.' + curr.searchTime)
        );
    });

    return newStorageArray.slice(0, maxStorage);
};

const _createNewFeedbackItemsToStore = function(data, newStorageArray) {
    let newItemsCounter = 0;
    let newItems = [];
    let existingItem;

    for (let i = 0; i < data.length; i++) {
        if (data[i].comment && data[i].comment.length > 0) {
            // Om data finns.
            existingItem = newStorageArray.find(
                newStorageItem => newStorageItem.text === data[i].comment
            );
            if (existingItem) {
                newItems[newItemsCounter] = {
                    text: existingItem.text,
                    counter: existingItem.counter + 1
                };
            } else {
                newItems[newItemsCounter] = {
                    text: data[i].comment,
                    counter: 1
                };
            }
            newItems[newItemsCounter].searchTime = Date.now();
            newItemsCounter++;
        }
    }

    return newItems;
};

const addFeedbackToStorage = function(data) {
    let newStorageArray = getFeedbackStorageAsArray() || [];
    let maxStorage = 10;
    let newItems = _createNewFeedbackItemsToStore(data, newStorageArray);

    if (newItems.length > 0) {
        newStorageArray = _mergeAndSortStorage(
            newStorageArray,
            newItems,
            maxStorage
        );
        localStore.setItem(storageKey, newStorageArray);
    }
};

service.getFeedbackHistory = function() {
    return getFeedbackStorageAsArray();
};

service.getStorageKey = function() {
    return storageKey;
};

service.submitData = function(data, cb, error) {
    ajax({
        url: rootUrl + 'save',
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data),
        traditional: true,
        statusCode: {
            200: function(response) {
                addFeedbackToStorage(data);
                if (response.failures?.length > 0) {
                    error(response);
                } else {
                    cb(response);
                }
            },
            400: function(response) {
                error(response);
            }
        }
    });
};

service.saveAutomaticFeedback = function(data, cb) {
    ajax({
        url: toLocalizedRiotUrl('/my/profile/save-automatic-feedback'),
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data),
        traditional: true,
        statusCode: {
            200: function(response) {
                let comments = [];
                if (data.message && data.message.length > 0) {
                    comments.push({ comment: data.message });
                    addFeedbackToStorage(comments);
                }
                cb(response);
            }
        }
    });
};

export default service;
